<!-- 采购合同 -->
<template>
   <div class='page_content'>
      <!-- 新增和修改弹框 -->
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <procurementContractAction v-if="showStatus" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></procurementContractAction>
      </el-drawer>
      <div class="page_content_top">
         <!-- 按钮权限 -->
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <!-- 查询条件 -->
            <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
            </vSearch>
         </div>
      </div>
      <!-- 列表数据 -->
      <div class="page_content_center">
         <el-table size="mini" @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                   highlight-current-row>
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                             :prop="tableValye.entityField" :label="tableValye.showField">
               <template slot-scope="scope">
                  <span v-if="tableValye.fieldType == 'formatter'">
                     <span v-for="item in JSON.parse(tableValye.formatterContent)">
                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                           {{ item.value }}
                        </el-tag>
                     </span>
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                  </span>
                  <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <!-- 分页 -->
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <!-- 检索方案 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
import VButton from '../../byComponents/vButton.vue';
 import procurementContractAction from "@/components/procurementContractAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: { VButton,procurementContractAction },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,//table高度
         getRequestData: {
            page: 1,
            rows: 30,
         },
         returnData: {
            total: 0, // 总条数
            list: []//数据列表
         },
         multipleSelection: [],
         buttonList: [],//按钮权限列表
         pageShowData: [],//检索、查询列表的动态表单
         formDataList: [],//新增、修改、查看动态表单数据
         actionData: {},//新增、修改、查看所需的数据
         showStatus: false,//是否打开新增或修改的弹框
         DialogVisible: false,//判断是否打开检索方案弹框
         seId: "",//检索方案Id
         seWidth: "",//检索方案弹框的宽度
         seTitle: "",//检索方案的名称
         sField: '',//赋值字段
         parentSearchData: {},//检索方案补充的查询列表的查询条件
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 动作集合 点击按钮
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true;//打开新增、修改弹框
               this.actionData = {
                  cate: 0,//判断是否是 0新增 1修改 2查看
                  formData: this.formDataList,//动态表单数据
                  oldData: "",//
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
               };
               break;
            case 1:
               if (this.returnData.list.length == 0) {
                  return this.$message.error("暂无数据")
               }
               if (this.multipleSelection.length != 1) {
                  this.$message({
                     message: "请先选中一条操作数据",
                     type: "error",
                  });
                  return false;
               }
               var dataInfo = this.multipleSelection[0];
               this.contractQueryDetailInfo(dataInfo)
               break;
            case 2:
               this.delDataAction()//删除
               break;
            case 3:
               this.submitDataAction()//提交
               break;
            case 4:
               this.downLoadFile()//下载附件
               break;
            case 6:
               this.anewCalculate()//重新计算
               break;
         }
      },
      async anewCalculate() {
         if (this.returnData.list.length == 0) {
            return this.$message.error("暂无数据")
         }
         if (this.multipleSelection.length == 0) {
            this.$message({
               message: "请先选中操作数据",
               type: "error",
            });
            return false;
         }
         var arr = []
         this.multipleSelection.forEach(item => {
            arr.push(item.conmId)
         })
         let responseData = await this.$http.contractresetContractFinish({ ids: arr })
         if (responseData.status == 200) {
            this.$message.success(responseData.message)
            this.getDataList()
         } else {
            this.$message.error(responseData.message)
         }
      },
      async contractQueryDetailInfo(dataInfo) {
         let responseData = await this.$http.contractQueryDetailInfo({ ids: [dataInfo.conmId] });
         if (responseData.status == 200) {
            this.showStatus = true;
            this.actionData = {
               cate: 1,//判断是否是 0新增 1修改 2查看
               formData: this.formDataList,//动态表单数据
               oldData: responseData.result,//选中的数据
               orderId: dataInfo.conmId,
               printSouce: "",
               printJurId: "",
            };
         }
      },
      // 提交审核
      async submitDataAction() {
         var dataInfo = []
         if (this.multipleSelection.length == 0) {
            this.$message({
               message: "请先选中要操作数据",
               type: "error",
            });
            return false;
         }
         this.multipleSelection.forEach(item => {
            dataInfo.push(item.conmId)
         })

         var subData = {
            ids: dataInfo,
         };
         let responseData = await this.$http.contractSubmit(subData);
         if (responseData.status == 200) {
            this.$message({
               type: "success",
               message: "操作成功",
            });

            this.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //自定义设计
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      //结束时间计算
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      //检索方案获取的数据清除
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      //获取检索方案弹框宽度
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      //获取检索方案弹框名称
      getSearchName(e) {
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.seId = sId;//检索方案Id
         this.sField = sField;//赋值字段
         this.DialogVisible = true;//判断是否打开弹框
         this.parentSearchData[type] = this.getRequestData[type]//查询条件赋值
      },

      //检索方案返回的数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)//赋值字段，赋值
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      // 子组件触发
      drawerCancel(e) {
         this.showStatus = false;
         if (e == 1) this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({
               //向窗口发送MessageEvent消息
               cmd: "returnFormJson",
               params: {
                  isPenetrate
               }, //参数
            },
               "*"
            );
         }
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path)
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId]
         })
         if (responseData.status == 200) {

            this.pageShowData = responseData.result
            this.formDataList = this.pageShowData.jurFormVoList
            var obj = {}//动态赋值查询条件
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            // 获取按钮权限
            this.getButtonList()
            // 获取数据列表
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getContract(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.total = responseData.result.total
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },
      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },
      //下载附件压缩包
      downLoadFile() {
         if (this.multipleSelection.length != 1) {
            this.$message({
               message: "请先选中一条操作数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.multipleSelection[0];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         window.location.href = this.$store.getters.getConfig.requestUrl + '/contract/downloadContract?ids=' + dataInfo.conmId
      },
      // 删除数据
      delDataAction() {
         if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
               this.$message({
                  message: '暂无数据',
                  type: 'error'
               });
               return false
            }
         }
         if (this.multipleSelection.length != 1) {
            this.$message({
               message: "请先选中一条操作数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.multipleSelection[0]
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.conmId]
            }
            let responseData = await this.$http.delContract(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });

      },

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.tableHeight = this.$common.getTableHeight()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
</style>